import axios from '@/utils/axios';

const getLocations = (appType, storeName, apiKey, password, accessToken, clientId, clientSecret, accountSourceId) => axios.post(`/sources/shopify/locations/${accountSourceId}`, {
  appType,
  storeName,
  apiKey,
  password,
  accessToken,
  clientId,
  clientSecret,
});

export default {
  getLocations,
};
